const CONSENT_KEY = 'crr-flash-consent';
const DISMISSED_KEY = 'crr-flash-dismissed';
const LEARNED_KEY = 'crr-flash-learned';
const DECK_KEY = 'crr-flash-active-deck';

export type FlashDeckType = 'crr' | 'cotier' | 'fluvial' | 'jetski';

export function getConsent(): boolean {
  try { return localStorage.getItem(CONSENT_KEY) === 'true'; } catch { return false; }
}

export function setConsent(v: boolean) {
  try { localStorage.setItem(CONSENT_KEY, String(v)); } catch { /* noop */ }
}

export function isDismissedSession(): boolean {
  try { return sessionStorage.getItem(DISMISSED_KEY) === 'true'; } catch { return false; }
}

export function dismissSession() {
  try { sessionStorage.setItem(DISMISSED_KEY, 'true'); } catch { /* noop */ }
}

export function getActiveDeck(): FlashDeckType {
  try {
    const val = localStorage.getItem(DECK_KEY);
    if (val === 'crr' || val === 'cotier' || val === 'fluvial' || val === 'jetski') return val;
  } catch { /* noop */ }
  return 'crr';
}

export function setActiveDeck(deck: FlashDeckType) {
  try { localStorage.setItem(DECK_KEY, deck); } catch { /* noop */ }
}

function getLearnedKey(deck?: FlashDeckType): string {
  const d = deck || getActiveDeck();
  return d === 'crr' ? LEARNED_KEY : `${LEARNED_KEY}-${d}`;
}

export function getLearned(deck?: FlashDeckType): Record<string, boolean> {
  try {
    const raw = localStorage.getItem(getLearnedKey(deck));
    return raw ? JSON.parse(raw) : {};
  } catch { return {}; }
}

export function toggleLearned(id: string, deck?: FlashDeckType): Record<string, boolean> {
  const learned = getLearned(deck);
  if (learned[id]) { delete learned[id]; } else { learned[id] = true; }
  try { localStorage.setItem(getLearnedKey(deck), JSON.stringify(learned)); } catch { /* noop */ }
  return learned;
}

export function resetLearned(deck?: FlashDeckType) {
  try { localStorage.removeItem(getLearnedKey(deck)); } catch { /* noop */ }
}
